import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { YearCashflow } from '../utils/financialCalculations';

const COLORS = { charging: '#0891B2', export: '#059669', sde: '#8B5CF6', ere: '#F59E0B' };
function fmtK(v: number): string { return Math.abs(v) >= 1e6 ? `€${(v / 1e6).toFixed(1).replace('.', ',')}M` : `€${Math.round(v / 1e3).toLocaleString('nl-NL')}k`; }

export default function RevenueStackChart({ cashflows, printMode }: { cashflows: YearCashflow[]; printMode?: boolean }) {
  const data = cashflows.filter(cf => cf.year > 0).map(cf => ({ year: `J${cf.year}`, Laden: Math.round(cf.chargingRevenue), Export: Math.round(cf.exportRevenue), 'SDE++': Math.round(cf.sdeRevenue), ERE: Math.round(cf.ereRevenue) }));
  return (
    <div className="bg-white rounded-xl border border-[#D9E2EC] p-4 shadow-sm mb-4">
      <div className="text-xs font-bold text-[#0B1F4A] mb-3">📊 Jaarlijkse Omzetverdeling</div>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
          <XAxis dataKey="year" tick={{ fontSize: 9, fill: '#8899AA' }} interval={1} />
          <YAxis tick={{ fontSize: 9, fill: '#8899AA' }} tickFormatter={v => fmtK(v)} width={55} />
          <Tooltip formatter={(value: number, name: string) => [fmtK(value), name]} contentStyle={{ fontSize: 11, borderRadius: 8 }} />
          <Legend wrapperStyle={{ fontSize: 10 }} />
          <Bar dataKey="Laden" stackId="rev" fill={COLORS.charging} isAnimationActive={!printMode} />
          <Bar dataKey="Export" stackId="rev" fill={COLORS.export} isAnimationActive={!printMode} />
          <Bar dataKey="SDE++" stackId="rev" fill={COLORS.sde} isAnimationActive={!printMode} />
          <Bar dataKey="ERE" stackId="rev" fill={COLORS.ere} radius={[3, 3, 0, 0]} isAnimationActive={!printMode} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
